export default "/images/vendor/flag-icon-css/flags/4x3/fi.svg?096c0ee26081bc0c577a2d4b3fcf298e";